import { Children, type ReactNode } from 'react';

/** Keep keyed panels mounted while matching reading/tab order to their visual positions. */
export function ClassroomWorkspace({
  swapped,
  children,
}: {
  readonly swapped: boolean;
  readonly children: ReactNode;
}) {
  const panels = Children.toArray(children);
  return (
    <div className={`fox-kifu-workspace${swapped ? ' classroom-workspace--swapped' : ''}`}>
      {swapped ? panels.reverse() : panels}
    </div>
  );
}
